import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { useT } from "@/i18n";

const CookieConsent = () => {
  const t = useT(
    {
      close: "Schließen",
      title: "Datenschutz & Cookies",
      text: "Diese Website verwendet ausschließlich technisch notwendige Cookies. Weitere Informationen finden Sie in der Datenschutzerklärung im Fußbereich der Seite.",
      accept: "Alle akzeptieren",
      decline: "Nur notwendige",
    },
    {
      close: "Close",
      title: "Privacy & cookies",
      text: "This website only uses technically necessary cookies. You can find more information in the privacy policy in the footer of this page.",
      accept: "Accept all",
      decline: "Necessary only",
    },
  );
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie-consent", "accepted");
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookie-consent", "declined");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center p-4 sm:items-center">
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm" />
      
      {/* Banner */}
      <div className="relative z-10 w-full max-w-2xl rounded-2xl bg-background border border-border shadow-2xl p-6 sm:p-8 animate-in fade-in slide-in-from-bottom-4 duration-500">
        <button
          onClick={handleDecline}
          className="absolute top-4 right-4 text-muted-foreground hover:text-foreground transition-colors"
          aria-label={t.close}
        >
          <X className="h-5 w-5" />
        </button>

        <div className="space-y-4">
          <h3 className="text-xl font-semibold text-foreground">
            {t.title}
          </h3>
          
          <p className="text-muted-foreground text-sm leading-relaxed">{t.text}</p>

          <div className="flex flex-col sm:flex-row gap-3 pt-2">
            <Button 
              onClick={handleAccept}
              className="flex-1 bg-primary hover:bg-primary/90"
            >
              {t.accept}
            </Button>
            <Button 
              onClick={handleDecline}
              variant="outline"
              className="flex-1"
            >
              {t.decline}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
